var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3501 1.53707L15.9987 2.47583L16.4452 3.93333L15.1808 3.03732L13.8854 3.92451L14.382 2.47289L13.0527 1.53707H14.7018L15.2264 0L15.7054 1.53707H17.3501Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3501 27.6035L15.9987 28.5422L16.4452 29.9997L15.1808 29.1037L13.8854 29.9894L14.382 28.5393L13.0527 27.6035H14.7018L15.2264 26.0664L15.7054 27.6035H17.3501Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29732 14.5507L2.94742 15.4895L3.39248 16.947L2.12803 16.051L0.832634 16.9382L1.32927 15.4866L0 14.5507H1.65055L2.17371 13.0137L2.65266 14.5507H4.29732Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15426 7.91402L4.80435 8.85278L5.24941 10.3088L3.98496 9.41427L2.68957 10.3L3.1862 8.84837L1.85693 7.91402H3.50602L4.03065 6.37695L4.50959 7.91402H6.15426Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7667 3.2441L9.4168 4.18286L9.86187 5.64037L8.59741 4.74435L7.30349 5.63154L7.79866 4.17992L6.47086 3.2441H8.11994L8.64457 1.70703L9.12204 3.2441H10.7667Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7074 3.2441L22.3561 4.18286L22.8026 5.64037L21.5367 4.74435L20.2428 5.63154L20.7379 4.17992L19.4101 3.2441H21.0592L21.5838 1.70703L22.0613 3.2441H23.7074Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4324 7.91402L27.081 8.85278L27.5275 10.3088L26.2631 9.41427L24.9691 10.3L25.4643 8.84837L24.1365 7.91402H25.7841L26.3087 6.37695L26.7892 7.91402H28.4324Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09804 21.0229L4.74667 21.9602L5.1932 23.4177L3.92874 22.5232L2.63335 23.4089L3.12852 21.9573L1.80072 21.0229H3.4498L3.97443 19.4844L4.45338 21.0229H6.09804Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7109 25.8579L9.36098 26.7981L9.80605 28.2541L8.54159 27.3596L7.2462 28.2453L7.74284 26.7937L6.41504 25.8579H8.06265L8.58875 24.3223L9.06622 25.8579H10.7109Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8195 25.8579L22.4681 26.7981L22.9146 28.2541L21.6502 27.3596L20.3548 28.2453L20.8514 26.7937L19.5222 25.8579H21.1712L21.6973 24.3223L22.1748 25.8579H23.8195Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4878 21.0229L27.1379 21.9602L27.583 23.4177L26.3185 22.5232L25.0246 23.4089L25.5198 21.9573L24.192 21.0229H25.8411L26.3657 19.4844L26.8446 21.0229H28.4878Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2346 14.5507L28.8847 15.4895L29.3283 16.947L28.0638 16.051L26.7699 16.9382L27.2651 15.4866L25.9373 14.5507H27.5863L28.111 13.0137L28.5899 14.5507H30.2346Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEu);
export default __webpack_public_path__ + "static/media/eu.c644fe75cafc216806737fc6de2da9c3.svg";
export { ForwardRef as ReactComponent };